var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { attrs: { cols: "auto" } },
    [
      _c(
        "v-avatar",
        {
          staticStyle: { "z-index": "1", "margin-right": "-75px!important" },
          attrs: { size: "65px", left: "", color: "teal darken-4" }
        },
        [
          _c(
            "v-icon",
            {
              staticStyle: {
                "margin-left": "-2px!important",
                "margin-bottom": "-4px!important"
              },
              attrs: { color: "white", size: "45" }
            },
            [_vm._v("\n      cci-rank-3\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-chip",
        {
          staticClass: "mx-3 my-1",
          attrs: { "x-large": "", pill: "", color: "light-green darken-4" }
        },
        [
          _c(
            "span",
            {
              staticClass: "pl-4 pr-4 heading h3 yellow--text text--lighten-2"
            },
            [_vm._v("  " + _vm._s(_vm.name))]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }